module.exports = __webpack_public_path__ + "static/media/slideshow-11.1660b5ac.jpeg";